import { AuthActions, AuthInfoActions } from '../constants/auth';

export const selectMsalContext = (state:any) => state.common[AuthActions.MsalContext];
export const selectIsProfileLoading = (state:any) => state.common[AuthInfoActions.IsProfileLoading];
export const selectProfile = (state:any) => state.common[AuthInfoActions.Profile];